import { Module, Store } from 'vuex';

export function registerAdapter(
  module: IPowerbarStoreModule<any, any>
): (store: Store<any>) => void {
  return (store: Store<any>) => {
    if (!store.hasModule(module.name)) {
      store.registerModule(module.name, module);
    }
  };
}
export function unregisterAdapter(
  module: IPowerbarStoreModule<any, any>
): (store: Store<any>) => void {
  return (store: Store<any>) => {
    if (store.hasModule(module.name)) {
      store.unregisterModule(module.name);
    }
  };
}

export type IPowerbarStoreModule<S, R> = Module<S, R> & {
  name: string;
  register?: (store: Store<any>) => void;
  unregister?: (store: Store<any>) => void;
};
